import { c as _c } from "react/compiler-runtime";
const Img = t0 => {
    const $ = _c(10);
    let props;
    let src;
    let t1;
    let t2;
    let width;
    if ($[0] !== t0) {
        const { withImgProxy: t3, noPlaceHolder: t4, containerHeight, width: t5, src: t6, ...t7 } = t0;
        t1 = t3;
        t2 = t4;
        width = t5;
        src = t6;
        props = t7;
        $[0] = t0;
        $[1] = props;
        $[2] = src;
        $[3] = t1;
        $[4] = t2;
        $[5] = width;
    }
    else {
        props = $[1];
        src = $[2];
        t1 = $[3];
        t2 = $[4];
        width = $[5];
    }
    t1 === undefined ? false : t1;
    t2 === undefined ? false : t2;
    let t3;
    if ($[6] !== props || $[7] !== src || $[8] !== width) {
        t3 = <img src={src} width={width} {...props}/>;
        $[6] = props;
        $[7] = src;
        $[8] = width;
        $[9] = t3;
    }
    else {
        t3 = $[9];
    }
    return t3;
};
export default Img;
